import { HTMLAttributes } from 'react'
import Link from 'next/link'

import Button from '@/components/base/button'
import Container from '@/components/base/container'
import Grid from '@/components/base/grid'
import Motion from '@/components/base/motion'
import Section from '@/components/base/section'
import SVGIcon from '@/components/base/svg-icon'
import Typography from '@/components/base/typography'

import { downloadRevealAnimation } from './animations'
import { cn } from '@/lib/utils'
import { WPLink } from '@/types'

export type DownloadProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    items: {
      link: WPLink
    }[]
  }>

const Download = ({ items, ...props }: DownloadProps) => {
  return (
    <Motion animation={downloadRevealAnimation}>
      {(motionRef) => (
        <Section ref={motionRef} {...props}>
          <Container>
            <Grid className="gap-y-[1.6rem]">
              {items?.map(({ link }, index) =>
                link?.url ? (
                  <div
                    className={cn([
                      'col-span-2',
                      'md:col-span-3',
                      'lg:col-span-4'
                    ])}
                    key={index}
                  >
                    <Button
                      isLiquid
                      asChild
                      variant="secondary"
                      full={true}
                      className="min-h-[4.8rem] py-spacing-xs [&_svg[data-background]]:stroke-border-menu-light"
                      endIcon={
                        <SVGIcon
                          symbol="pdf-icon"
                          className={cn([
                            'ml-auto size-[1.8rem] shrink-0 fill-current'
                          ])}
                        />
                      }
                      data-motion-button
                    >
                      <Link
                        href={link.url}
                        target={link.target}
                        scroll={false}
                      >
                        <Typography variant="regular">
                          {link.title}
                        </Typography>
                      </Link>
                    </Button>
                  </div>
                ) : null
              )}
            </Grid>
          </Container>
        </Section>
      )}
    </Motion>
  )
}

export default Download
